import CryptoJS from 'crypto-js'

const prefix = '-usuario'
const secretKey = 'my-secret-key'

const encryptData = data => {
  try {
    return CryptoJS.AES.encrypt(JSON.stringify(data), secretKey).toString()
  } catch (error) {
    return null
  }
}

const decryptData = ciphertext => {
  try {
    if (!ciphertext) return null
    const bytes = CryptoJS.AES.decrypt(ciphertext, secretKey)
    const decryptedData = bytes.toString(CryptoJS.enc.Utf8)
    if (!decryptedData) return null
    return JSON.parse(decryptedData)
  } catch (error) {
    return null
  }
}

const LocalStorage = {
  get: key => {
    const data = localStorage.getItem(key + prefix)
    return data ? decryptData(data) : null
  },
  set: (key, value) => {
    const encryptedData = encryptData(value)
    if (encryptedData) {
      localStorage.setItem(key + prefix, encryptedData)
    }
  },
  remove: key => {
    return localStorage.removeItem(key + prefix)
  },
  clear: () => {
    return localStorage.clear()
  },
}

export default LocalStorage
